import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corPid',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      options: []
    },
    {
      field: 'days',
      type: 'input',
      label: '天数',
      placeholder: '请输入天数',
    },
    {
      field: 'usedBy',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人',
    },
    {
      field: 'queryDate',
      type: 'datepicker',
      label: '查询日期',
      otherOptions: {
        'value-format': 'YYYY-MM',
        type: 'month'
      }
    }
  ]
}
